import './accordian.scss';

export default class Accordian {
    constructor (accordian) {
        if (!accordian) {
            return;
        }

        this.accordian = accordian;
        this.accordianElements = accordian.querySelectorAll('.js-accordian-element');
        this.init();
    }
    
    init() {
        this.accordianElements.forEach(element => {
            let opener = element.querySelector('.js-accordian-opener');
            let answerHolder = element.querySelector('.js-accordian-answer-holder');
            let answer = element.querySelector('.js-accordian-answer');
            
            opener.addEventListener('click', ()=>{
                if(element.classList.contains('closed')) {
                    setTimeout(()=>{
                        element.classList.remove('closed');
                        answer.style.height = answerHolder.offsetHeight+'px';
                        // eslint-disable-next-line no-console
                        console.log(answerHolder.offsetHeight);
                    }, 20);
                }
                else {
                    setTimeout(()=>{
                        answer.style.height = '0px';
                        element.classList.add('closed');
                    }, 20);
                }
                this.closeAll();
            });
        });
    }

    closeAll() {
        this.accordianElements.forEach(element => {
            let answer = element.querySelector('.js-accordian-answer');
            answer.style.height = '0px';
            element.classList.add('closed');
        });
    }
}
